// Meal type filter state stores two kinds of keys:
//   - group keys (__mealTypeGroup__Breakfast): which slideout/quick-filter option is selected
//   - product type / label keys (Add On Breakfast Bundle): which meals match
// Group keys keep overlapping options (e.g. Breakfast vs Bundles sharing a product type)
// independently selectable. Meal matching ignores group keys.
export const MEAL_TYPE_GROUP_KEY_PREFIX = '__mealTypeGroup__';

export const getMealTypeGroupKey = identity => `${MEAL_TYPE_GROUP_KEY_PREFIX}${identity}`;

export const isMealTypeGroupKey = key =>
  typeof key === 'string' && key.startsWith(MEAL_TYPE_GROUP_KEY_PREFIX);

export const getMealTypeGroupIdentityFromKey = key =>
  isMealTypeGroupKey(key) ? key.slice(MEAL_TYPE_GROUP_KEY_PREFIX.length) : null;
